import React, { useEffect, useRef, useState } from 'react';

import { ComparisonKeysStyled } from './ComparePlansStyled';

export interface ComparisonKeysProps {
  setComparisonKeys?: (keys: string[]) => void;
  className?: string;
}

export const ComparisonKeys = ({
  setComparisonKeys,
  className,
}: ComparisonKeysProps) => {
  const comparisonKeys = ['In-networks', 'Out-networks', 'Preferred-networks'];

  const [comparisonKeyCheckbox, setComparisonKeyCheckbox] =
    useState<boolean>(false);
  const updatedCheckboxRef = useRef(comparisonKeyCheckbox);

  const elementCheckboxes = document.getElementsByClassName(
    'comparison-key-checkbox'
  );

  let checkedComparisonKeys: string[] = [];

  const handleComparisonKeyCheckbox = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.tagName === 'INPUT') {
      setComparisonKeyCheckbox(e?.target?.checked);
      updatedCheckboxRef.current = e?.target?.checked;
    }

    checkedComparisonKeys = [];

    const checkedKeys = document.querySelectorAll(
      '.comparison-key-checkbox input:checked'
    );
    checkedKeys.forEach((key) => {
      checkedComparisonKeys.push(key.getAttribute('name') ?? '');
    });

    setComparisonKeys && setComparisonKeys([...checkedComparisonKeys]);

    // moved this chunk into the event and out of a useEffect triggered from updating checked comparisonKeys to get around lint warning
    if (
      document.querySelectorAll('.comparison-key-checkbox input:checked')
        .length === 1
    ) {
      document
        .querySelectorAll('.comparison-key-checkbox input:checked')[0]
        .setAttribute('disabled', 'true');
    } else {
      const checkedInputs = document.querySelectorAll(
        '.comparison-key-checkbox input:checked:disabled'
      );
      if (
        checkedInputs.length > 0 &&
        checkedInputs[0]?.hasAttribute('disabled')
      ) {
        checkedInputs[0]?.removeAttribute('disabled');
      }
    }
  };

  useEffect(() => {
    // attached event listener to all checkboxes
    for (let i = 0; i < elementCheckboxes.length; i++) {
      elementCheckboxes[i].addEventListener('change', (event) => {
        if (event.target) {
          const target = event.target as HTMLInputElement; // Cast event target to HTMLInputElement
          elementCheckboxes[i]?.setAttribute(
            'value',
            target.checked.toString()
          ); // Access 'checked' property
          handleComparisonKeyCheckbox(
            event as unknown as React.ChangeEvent<HTMLInputElement>
          );
        }
      });
    }
  });

  useEffect(() => {
    // set the checkboxes checked which has in-networks and out-networks as default values
    const inNetworksCheckbox = document.getElementById('checkbox-In-networks');
    const outNetworksCheckbox = document.getElementById(
      'checkbox-Out-networks'
    );
    if (inNetworksCheckbox && outNetworksCheckbox) {
      inNetworksCheckbox.setAttribute('checked', 'true');
      outNetworksCheckbox.setAttribute('checked', 'true');
      setComparisonKeys && setComparisonKeys(['In-networks', 'Out-networks']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ComparisonKeysStyled className={className || ''}>
      {comparisonKeys.map((comparisonKey, index) => (
        <ps-checkbox
          key={index}
          input-id={`checkbox-${comparisonKey}`}
          extra-class="comparison-key-checkbox"
          name={comparisonKey}
          label={comparisonKey}
          value={comparisonKeyCheckbox}
          onChange={handleComparisonKeyCheckbox}
          checked={comparisonKeyCheckbox ? comparisonKeyCheckbox : null}
        />
      ))}
    </ComparisonKeysStyled>
  );
};
